import { CommonModule, DecimalPipe } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { isEmpty, parseJSON } from 'app/shared/utils';

@Component({
    selector: 'app-product-card',
    standalone: true,
    imports: [CommonModule, MatIconModule, TranslateModule, DecimalPipe],
    templateUrl: './product-card.component.html',
})
export class ProductCardComponent implements OnInit, OnChanges {
    @Input() product: any;
    @Input() index: number;
    @Input() isRecom: boolean = false;
    @Input() selectedLanguage: string;
    @Input() isDisabled: boolean = false;
    @Input() isBRP_CGC_Flow: boolean = false;
    @Input() faSelected: boolean = false;
    @Input() productDetails: any;
    @Input() isSelected: boolean = false;
    @Input() isP2POnly: boolean = false;
    @Input() changeBranch: boolean = false;
    @Input() limitExceeded: boolean = false;
    @Input() selectedBranch: any = [];
    @Output() recommendedProductSelect: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() showDialog: EventEmitter<any> = new EventEmitter<any>();
    @Output() handleChangeBranch: EventEmitter<any> = new EventEmitter<any>();
    showMore: boolean = false;
    isNextRow: boolean = false;
    showBranch: boolean = false;
    currentBranch: {} = {};
    gaEventId: string = '';
    gaEventCategory: string = '';
    gaEventLable: string = '';

    ngOnInit() {
        if (!this.isP2POnly) {
            if (this.index > 2) {
                this.isNextRow = true;
            }
        } else {
            this.isNextRow = false;
        }
        this.setupGAEvent();
    }

    setupGAEvent() {
        if (this.isP2POnly) {
            this.gaEventId = `${this.product.prodCode}_product_selection_no_product_match_click`;
            this.gaEventCategory = 'No Product Match Button';
            this.gaEventLable = `Product Selection Button`;
        } else {
            this.gaEventId = `${this.product.prodCode}_select_button_match_click`;
            this.gaEventCategory = 'Matched Products Page Button';
            this.gaEventLable = `Select Button`;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if (changes) {
        //     this.selectedBranch.forEach((item) => {
        //         if (
        //             this.productDetails?.fiId === item?.fiId &&
        //             this.isSelected
        //         ) {
        //             this.currentBranch = item;
        //             this.showBranch = true;
        //         } else {
        //             this.showBranch = false;
        //         }
        //     });
        // }
        this.setupGAEvent();
    }

    ngDoCheck() {
        this.selectedBranch.forEach((item) => {
            if (this.productDetails?.fiId === item?.fiId && this.isSelected) {
                this.currentBranch = item;
                this.showBranch = true;
            } else {
                this.showBranch = false;
            }
        });
    }

    getImgUrl(img) {
        if (!isEmpty(img)) {
            return img;
        } else if (isEmpty(img)) {
            let url = '';
            if (this.selectedLanguage == 'bm') {
                url = '/assets/images/image_not_available_bm.webp';
            } else if (this.selectedLanguage == 'en') {
                url = '/assets/images/image_not_available_en.webp';
            }
            return url;
        }
    }

    toggleSelect() {
        this.isSelected = !this.isSelected;
    }

    toggleDesc() {
        this.showMore = !this.showMore;
    }

    onSelectProduct(prodCode, prodCat) {
        this.isSelected = !this.isSelected;
        if (!this.isSelected) {
            this.showBranch = false;
        }
        this.recommendedProductSelect.emit({
            prodCode,
            isSelected: this.isSelected,
            productDetails: this.productDetails,
            prodCat: prodCat,
        });
    }

    showDialogBox() {
        this.showDialog.emit({ ...this.productDetails, isRecProd: true });
    }

    // changeBranch() {
    //     this.handleChangeBranch.emit(this.productDetails);
    // }

    hasTransferTag(product: any): boolean {
        if (!product.prodTag) return false;
        try {
            const tags = parseJSON(product.prodTag);
            return Array.isArray(tags) && tags.includes('Fast Transfer');
        } catch {
            return false;
        }
    }
}
